import { REGEXP_EMAIL_LABEL } from '@app/transfer-bundle/config/transfer-config';

export function extractEmails(recipientEmailInput) {
  let emails;

  // Clean-up input
  emails = recipientEmailInput.replace(/^\s+|\s+$/g, ''); // trim string
  emails = emails.replace(/\s+/g, ' '); // convert multispace in 1 space

  // Split multiple
  let addresses = emails.split(/\s*,\s*|\s*;\s*|\s+/);
  // Filter out bad ones
  addresses = addresses.filter((email) => !!email.match(REGEXP_EMAIL_LABEL));

  // Get only the email, not the labels.
  return addresses.map((email) => {
    const result = email.match(REGEXP_EMAIL_LABEL);

    if (result[3]) {
      return result[3];
    }
    return result[6];
  });
}
